import { NotificationType } from '../models/Notification';
import { NotificationRepository } from '../repositories/NotificationRepository';
import { logger } from '@/src/core/utils';

export class UpdateNotificationPreferenceUseCase {
  constructor(private notificationRepository: NotificationRepository) {}

  async execute(userId: string, type: NotificationType, enabled: boolean): Promise<void> {
    logger.debug('UpdateNotificationPreference', 'Updating preference', { userId, type, enabled });
    await this.notificationRepository.updatePreference(userId, type, enabled);
  }
}
